import { c as _c } from "react/compiler-runtime";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
const ButtonStyled = styled(Button)(({
  theme: {
    palette,
    spacing,
    radius
  }
}) => ({
  '&&': {
    border: `1px solid ${palette.interaction.border}`,
    backgroundColor: palette.layout.background.navigation,
    padding: spacing(2, 2),
    width: '100%',
    color: palette.text.onMain,
    borderRadius: 0,
    marginTop: -1,
    '&:first-of-type': {
      borderTopLeftRadius: radius.interaction,
      borderTopRightRadius: radius.interaction
    },
    '&:last-of-type': {
      borderBottomLeftRadius: radius.interaction,
      borderBottomRightRadius: radius.interaction
    },
    '&:focus, &:hover': {
      borderColor: palette.interaction.hover,
      zIndex: 1
    },
    '&:active': {
      backgroundColor: palette.layout.background.navigationAlternative
    }
  },
  '& .MuiButton-startIcon + span': {
    flexGrow: 1,
    textAlign: 'left'
  },
  '& .MuiButton-startIcon .MuiSvgIcon-root': {
    width: 24,
    height: 24
  }
})) as typeof Button;
interface Props {
  children: string;
  onClick: (value: string) => void;
}
export default function ConversationStarterButton(t0) {
  const $ = _c(9);
  const {
    children,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AutoAwesomeIcon sx={{
      pr: 1
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== onClick) {
    t2 = () => onClick(children);
    $[1] = children;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <Typography variant="body" component="div">{children}</Typography>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <ButtonStyled disableFocusRipple={true} disableRipple={true} startIcon={t1} variant="tertiary" onClick={t2}>{t3}</ButtonStyled>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}